import { render, staticRenderFns } from "./iframeBox.vue?vue&type=template&id=65671cfd"
import script from "./iframeBox.vue?vue&type=script&lang=js"
export * from "./iframeBox.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/root/workspace/frontend_coduck_business_lcPT/node_modules/_vue-hot-reload-api@2.3.4@vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('65671cfd')) {
      api.createRecord('65671cfd', component.options)
    } else {
      api.reload('65671cfd', component.options)
    }
    module.hot.accept("./iframeBox.vue?vue&type=template&id=65671cfd", function () {
      api.rerender('65671cfd', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/viewsteacher/courseTrain/meredu/components/iframeBox.vue"
export default component.exports